import { Link } from 'react-router-dom'
import './Footer.css'

const Footer = () => {
  const currentYear = new Date().getFullYear()
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              Sign in Seconds
            </Link>
            <p className="footer-tagline">
              The e-signature tool for small businesses
            </p>
          </div>
          
          <div className="footer-links">
            <div className="footer-links-group">
              <h4 className="footer-links-title">Product</h4>
              <ul className="footer-links-list">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/upload">New Document</Link></li>
              </ul>
            </div>
            
            <div className="footer-links-group">
              <h4 className="footer-links-title">Legal</h4>
              <ul className="footer-links-list">
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/terms-of-service">Terms of Service</Link></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {currentYear} Sign in Seconds. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
